export default "__VITE_ASSET__6a1538a1__"